import { theme } from '@baseapp-frontend/design-system-mui'
import { styled, Box, Typography } from '@mui/material'
import Image from 'next/image'

export const SimilarProjectsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.surface[900],
  padding: theme.spacing(5, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(11, 0),
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.h3,
  color: theme.palette.surface['100'],
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    ...theme.typography.h2,
  },
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle1,
  color: theme.palette.surface['100'],
}))

export const SubtitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(10),
}))

export const SimilarProjectListWrapper = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  gap: theme.spacing(4),
}))

export const SimilarProjectItemContainer = styled(Box)(({ theme }) => ({
  width: 229,
  [theme.breakpoints.up('sm')]: {
    width: 342,
  },
}))

export const SimilarProjectImageContainer = styled(Box)(() => ({
  aspectRatio: '1/1',
  width: 229,
  height: 229,
  cursor: 'pointer',
  position: 'relative',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    width: 342,
    height: 342,
  },
}))

export const ProjectImageWrapper = styled(Box)(({ theme }) => ({
  width: `calc(100% - ${theme.spacing(6)})`,
  height: `calc(100% - ${theme.spacing(6)})`,
  position: 'absolute',
  margin: theme.spacing(3),
  left: 0,
  top: 0,
}))

export const ProjectImage = styled(Image)(() => ({
  filter: 'drop-shadow(0px 0px 10px #00000070)',
})) as typeof Image

export const FrameAndBackgroundWrapper = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  padding: '2%',
  borderRadius: '10%',
  overflow: 'hidden',
}))

export const ImageFrame = styled(Image)(() => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  backgroundClip: 'border-box',
  top: 0,
  left: 0,
}))

export const ImageBackground = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  backgroundImage: `
    linear-gradient(140deg, transparent 0%, rgba(0,0,0,0.6) 100%),
    radial-gradient(
      circle at 90% 10px,
      rgba(255, 255, 255, 0.2), 
      transparent 200px
    )`,
}))

export const ProjectTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.surface['100'],
  cursor: 'pointer',
  marginBottom: theme.spacing(1),
}))

export const ProjectDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.surface['100'],
}))
